export const styles = {
  container: { marginTop: 16 },
  tableContainer: {
    borderRadius: 16,
    padding: '16px 32px',
    backgroundColor: 'white',
    marginLeft: 24,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  illustrationContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  descriptionUnderline: {
    color: '#505050',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: -0.154,
  },
  descriptionContainer: {
    marginBottom: 16,
  },
  hintContainer: {
    marginTop: 16,
    width: 330,
  },
  trashIcon: `url("data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><g opacity='0.58'><path d='M14 3.98763C11.78 3.76763 9.54667 3.6543 7.32 3.6543C6 3.6543 4.68 3.72096 3.36 3.8543L2 3.98763' fill='black' fill-opacity='0.56'/><path d='M14 3.98763C11.78 3.76763 9.54667 3.6543 7.32 3.6543C6 3.6543 4.68 3.72096 3.36 3.8543L2 3.98763' stroke='%23707087' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/><path d='M5.66602 3.31398L5.81268 2.44065C5.91935 1.80732 5.99935 1.33398 7.12602 1.33398H8.87268C9.99935 1.33398 10.086 1.83398 10.186 2.44732L10.3327 3.31398' stroke='%23707087' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/><path d='M12.5669 6.09375L12.1336 12.8071C12.0603 13.8537 12.0003 14.6671 10.1403 14.6671H5.86026C4.00026 14.6671 3.94026 13.8537 3.86693 12.8071L3.43359 6.09375' stroke='%23707087' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/><path d='M6.88672 11H9.10672' stroke='%23707087' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/><path d='M6.33398 8.33398H9.66732' stroke='%23707087' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></g></svg>")`,
}
